import * as defaultConst from '../../../constants/default_constants'
import * as linkConst from '../../../constants/link_constants'
import Validators from '../validators'
import createSubentityConfs from './subentity'
import { BaseManipStateFn, BaseTableState } from '../base'

export default (store) => {
  class ManipState extends BaseManipStateFn(store) {
    requiredOptions = [
      'ContractCurrency',
      'Countries',
      'FlyPrivatePlatforms',
      'PricingTiers',
      'TimeZones',
      'VodSaleTypes',
      linkConst.LOAD_OPTIONS.flyprivate_pricings,
      linkConst.LOAD_OPTIONS.timeZonesList
    ]

    onSaved (saved) {
      super.onSaved(saved)
      store.markDirty('flyprivate_pricings')
    }

    prepareNew () {
      this.record.set('pricings', [])
    }

    createtitle = store.__(linkConst.LINK_PRICING_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_CREATE)
    edittitle = store.__(linkConst.LINK_PRICING_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_EDIT)
    subentities = createSubentityConfs(store)
    timeRestriction = 'flyprivate_pricing'
    validators = {
      platform: Validators.isMandatory(store),
      tier: Validators.isMandatory(store),
      type_sale: Validators.isMandatory(store),
      _global: [
        Validators.regionOverlapping(store, null, true),
        (vals) => {
          for (const item of store.options.get('flyprivate_pricings')) {
            if ((item.platform === vals.get('platform') &&
              item.tier === vals.get('tier') &&
              item.type_sale === vals.get('type_sale')) &&
              (!vals.has('id') || (vals.has('id') && parseInt(item.id) !== parseInt(vals.get('id'))))
            ) {
              return [store.__('Pricing [platform, tier, sale type] must be unique. There is a collision with the pricing ID: ') + item.id]
            }
          }
        }]
    }
  }

  class TableState extends BaseTableState {
    attrs = [
      'id',
      'platform_enumtext',
      'tier_enumtext',
      'type_sale',
      'valid_from',
      'valid_to',
      'utc_flag',
      'quality_mobile_price',
      'quality_sd_price',
      'quality_hd_price',
      'quality_uhd_price',
      'period_length',
      'period_time_unit',
      'coming_soon_flag',
      'regions',
      'currency_cd'
    ]

    headertitles = [
      store.__('ID'),
      store.__('Platform'),
      store.__('Tier'),
      store.__('Type sale'),
      store.__('Valid from'),
      store.__('Valid to'),
      store.__('UTC time'),
      store.__('Mobile price'),
      store.__('SD price'),
      store.__('HD price'),
      store.__('UHD price'),
      store.__('Period length'),
      store.__('Period unit'),
      store.__('Coming soon'),
      store.__('Regions'),
      store.__('Currency')
    ]

    timeRestriction = 'flyprivate_pricing'
    title = store.__(linkConst.LINK_PRICING_TITLE)
    defaultSort = linkConst.DEFAULT_SORT[linkConst.LINK_PRICING]

    disableAttrs = {
      disable: [],
      hide: [
        'id',
        'platform',
        'tier',
        'type_sale']
    }

    requiredOptions = [
      'ContractCurrency',
      'Countries',
      'FlyPrivatePlatforms',
      'PricingTiers',
      'VodSaleTypes',
      linkConst.LOAD_OPTIONS.timeZonesList
    ]
  }

  return { ManipState, TableState }
}
